export default "__VITE_PUBLIC_ASSET__60f233a5__"